import * as types from "../../actionTypes/Dashboard/activityActionTypes";

const initial = {
    ActivitySearch: {
      data: {},
      apiState: "initial",
    },
    GetActivitiesListDetails: {
      data: {},
      apiState: "initial",
    },
    GetActivityExtraDetails: {
      data: [],
      apiState: "initial",
    },
    GetActivityAgeBand: {
      data: {},
      apiState: "initial",
    },
    GetActivityCategories: {
      data: {},
      apiState: "initial",
    },
    GetActivityAllDetails: {
      data: {},
      apiState: "initial",
    },
    GetActivityProductInfo: {
      data: {},
      apiState: "initial",
    },
    ActivityPreBookDetails: {
      data: {},
      apiState: "initial",
    },
    ActivityCheckoutDetails: {},
    callActivitiesListApi: false,
    callActivityExtraDetailsApi: false,
    callActivityAllDetailsApi: false,
    passportDetailsByBookingIdDetails: {},
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const ActivityReducer = (state = initial, action: any) => {
  switch (action.type) {
    // ------------------> ACTIVITY_SEARCH start
    case types.POST_ACTIVITY_SEARCH.STARTED:
      return { ...state, ActivitySearch: { data: {}, apiState: "started" } };
    case types.POST_ACTIVITY_SEARCH.FULLFILLED:
      return {
        ...state,
        ActivitySearch: { data: action.payload, apiState: "fulfilled" },
      };
    case types.POST_ACTIVITY_SEARCH.REJECTED:
      return { ...state, ActivitySearch: { data: {}, apiState: "rejected" } };
    case types.RESET_POST_ACTIVITY_SEARCH:
      return { ...state, ActivitySearch: { data: {}, apiState: "initial" } };
    // ------------------> ACTIVITY_SEARCH end

    // ------------------> GET_ACTIVITIES_LIST start
    case types.GET_ACTIVITIES_LIST.STARTED:
      return {
        ...state,
        GetActivitiesListDetails: { data: {}, apiState: "started" },
      };
    case types.GET_ACTIVITIES_LIST.FULLFILLED:
      return {
        ...state,
        GetActivitiesListDetails: {
          data: action.payload,
          apiState: "fulfilled",
        },
      };
    case types.GET_ACTIVITIES_LIST.REJECTED:
      return {
        ...state,
        GetActivitiesListDetails: { data: {}, apiState: "rejected" },
      };
    case types.RESET_GET_ACTIVITIES_LIST:
      return {
        ...state,
        GetActivitiesListDetails: { data: {}, apiState: "initial" },
      };
    // ------------------> GET_ACTIVITIES_LIST end

    // ------------------> GET_ACTIVITY_EXTRA_DETAILS start
    case types.GET_ACTIVITY_EXTRA_DETAILS.STARTED:
      return {
        ...state,
        GetActivityExtraDetails: { ...state.GetActivityExtraDetails, apiState: "started" },
      };
    case types.GET_ACTIVITY_EXTRA_DETAILS.FULLFILLED:
      return {
        ...state,
        GetActivityExtraDetails: {
          data: [...(state.GetActivityExtraDetails?.data ?? []), ...(action?.payload?.data?.data ?? [])],
          apiState: "fulfilled",
        },
      };
    case types.GET_ACTIVITY_EXTRA_DETAILS.REJECTED:
      return {
        ...state,
        GetActivityExtraDetails: { ...state.GetActivityExtraDetails, apiState: "rejected" },
      };
    case types.RESET_GET_ACTIVITY_EXTRA_DETAILS:
      return {
        ...state,
        GetActivityExtraDetails: { data: [], apiState: "initial" },
      };
    // ------------------> GET_ACTIVITY_EXTRA_DETAILS end

    // ------------------> GET_ACTIVITY_AGE_BAND start
    case types.GET_ACTIVITY_AGE_BAND.STARTED:
      return {
        ...state,
        GetActivityAgeBand: { data: {}, apiState: "started" },
      };
    case types.GET_ACTIVITY_AGE_BAND.FULLFILLED:
      return {
        ...state,
        GetActivityAgeBand: { data: action.payload, apiState: "fulfilled" },
      };
    case types.GET_ACTIVITY_AGE_BAND.REJECTED:
      return {
        ...state,
        GetActivityAgeBand: { data: {}, apiState: "rejected" },
      };
    case types.RESET_GET_ACTIVITY_AGE_BAND:
      return {
        ...state,
        GetActivityAgeBand: { data: {}, apiState: "initial" },
      };
    // ------------------> GET_ACTIVITY_AGE_BAND end

    // ------------------> GET_ACTIVITY_CATEGORIES start
    case types.GET_ACTIVITY_CATEGORIES.STARTED:
      return {
        ...state,
        GetActivityCategories: { data: {}, apiState: "started" },
      };
    case types.GET_ACTIVITY_CATEGORIES.FULLFILLED:
      return {
        ...state,
        GetActivityCategories: { data: action.payload, apiState: "fulfilled" },
      };
    case types.GET_ACTIVITY_CATEGORIES.REJECTED:
      return {
        ...state,
        GetActivityCategories: { data: {}, apiState: "rejected" },
      };
    case types.RESET_GET_ACTIVITY_CATEGORIES:
      return {
        ...state,
        GetActivityCategories: { data: {}, apiState: "initial" },
      };
    // ------------------> GET_ACTIVITY_CATEGORIES end

    // ------------------> GET_ACTIVITY_ALL_DETAILS start
    case types.GET_ACTIVITY_ALL_DETAILS.STARTED:
      return {
        ...state,
        GetActivityAllDetails: { data: {}, apiState: "started" },
      };
    case types.GET_ACTIVITY_ALL_DETAILS.FULLFILLED:
      return {
        ...state,
        GetActivityAllDetails: { data: action.payload, apiState: "fulfilled" },
      };
    case types.GET_ACTIVITY_ALL_DETAILS.REJECTED:
      return {
        ...state,
        GetActivityAllDetails: { data: {}, apiState: "rejected" },
      };
    case types.RESET_GET_ACTIVITY_ALL_DETAILS:
      return {
        ...state,
        GetActivityAllDetails: { data: {}, apiState: "initial" },
      };
    // ------------------> GET_ACTIVITY_ALL_DETAILS end

    // ------------------> GET_ACTIVITY_PRODUCT_INFO start
    case types.GET_ACTIVITY_PRODUCT_INFO.STARTED:
      return {
        ...state,
        GetActivityProductInfo: { data: {}, apiState: "started" },
      };
    case types.GET_ACTIVITY_PRODUCT_INFO.FULLFILLED:
      return {
        ...state,
        GetActivityProductInfo: { data: action.payload, apiState: "fulfilled" },
      };
    case types.GET_ACTIVITY_PRODUCT_INFO.REJECTED:
      return {
        ...state,
        GetActivityProductInfo: { data: {}, apiState: "rejected" },
      };
    case types.RESET_GET_ACTIVITY_PRODUCT_INFO:
      return {
        ...state,
        GetActivityProductInfo: { data: {}, apiState: "initial" },
      };
    // ------------------> GET_ACTIVITY_PRODUCT_INFO end

    // ------------------> ACTIVITY_PRE_BOOK start
    case types.ACTIVITY_PRE_BOOK.STARTED:
      return {
        ...state,
        ActivityPreBookDetails: { data: {}, apiState: "started" },
      };
    case types.ACTIVITY_PRE_BOOK.FULLFILLED:
      return {
        ...state,
        ActivityPreBookDetails: { data: action.payload, apiState: "fulfilled" },
      };
    case types.ACTIVITY_PRE_BOOK.REJECTED:
      return {
        ...state,
        ActivityPreBookDetails: { data: {}, apiState: "rejected" },
      };
    case types.RESET_ACTIVITY_PRE_BOOK:
      return {
        ...state,
        ActivityPreBookDetails: { data: {}, apiState: "initial" },
      };
    // ------------------> ACTIVITY_PRE_BOOK end

    // ------------------> ACTIVITY_CHECKOUT start
    case types.ACTIVITY_CHECKOUT.FULLFILLED:
      return { ...state, ActivityCheckoutDetails: action.payload };
    case types.ACTIVITY_CHECKOUT.REJECTED:
      return {
        ...state,
        ActivityCheckoutDetails: { data: {}, apiState: "rejected" },
      };
    // ------------------> ACTIVITY_CHECKOUT end

    // these are used to know whether to call particular apis or not
    case types.SET_CALL_ACTIVITIES_LIST_API:
      return { ...state, callActivitiesListApi: action.payload };
    case types.SET_CALL_ACTIVITY_EXTRA_DETAILS_API:
      return { ...state, callActivityExtraDetailsApi: action.payload };
    case types.SET_CALL_ACTIVITY_ALL_DETAILS_API:
      return { ...state, callActivityAllDetailsApi: action.payload };
    case types.PASSPORT_DETAILS_BY_BOOKINGID.FULLFILLED:
      return { ...state, passportDetailsByBookingIdDetails: action.payload };
    case types.PASSPORT_DETAILS_BY_BOOKINGID.REJECTED:
      return { ...state, passportDetailsByBookingIdDetails: {} };
    default:
      return state;
  }
};

export default ActivityReducer;
